import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  function removeItemFromArray(arr, value) {
    //console.log("removeItemFromArray", value, arr);
    let index = -1;
    arr.map((item) => {
      //console.log("removeItemFromArray", item);
      if (value.id === item.checklistTaskTemplate.id) {
        index = arr.indexOf(item);
      }
      return item;
    });
    //console.log("removeItemFromArray", value, arr);
    if (index !== -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
  switch (actions.type) {
    case types.FETCH_CHECKLIST_TASK_TEMPLATE_PENDING:
      return {
        ...state,
        pending: true,
        checklistTaskTemplates: [],
      };
    case types.FETCH_CHECKLIST_TASK_TEMPLATE_SUCCESS:
      return {
        ...state,
        pending: false,
        checklistTaskTemplates: actions.payload,
      };
    case types.FETCH_CHECKLIST_TASK_TEMPLATE_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };

    case types.FETCH_CHECKLIST_TASKS_TEMPLATE_PENDING:
      return {
        ...state,
        pending: true,
        checklistTaskTemplates: [],
      };
    case types.FETCH_CHECKLIST_TASKS_TEMPLATE_SUCCESS:
      return {
        ...state,
        pending: false,
        checklistTaskTemplates: actions.payload,
      };
    case types.FETCH_CHECKLIST_TASKS_TEMPLATE_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    case types.UPDATE_CHECKLIST_TASK_TEMPLATE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.UPDATE_CHECKLIST_TASK_TEMPLATE_SUCCESS:
      return {
        ...state,
        pending: false,
        checklistTaskTemplates: state.checklistTaskTemplates.map((item) => {
          if (
            actions.payload.data.checklistTaskTemplate.id ===
            item.checklistTaskTemplate.id
          ) {
            item = { ...actions.payload.data };
          }
          return item;
        }),
        // actions.payload,
      };
    case types.UPDATE_CHECKLIST_TASK_TEMPLATE_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    case types.INSERT_CHECKLIST_TASK_TEMPLATE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.INSERT_CHECKLIST_TASK_TEMPLATE_SUCCESS:
      return {
        ...state,
        pending: false,
        checklistTaskTemplates: [
          ...state.checklistTaskTemplates,
          actions.payload.data,
        ],
        // actions.payload,
      };
    case types.INSERT_CHECKLIST_TASK_TEMPLATE_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    case types.REMOVE_CHECKLIST_TASK_TEMPLATE_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.REMOVE_CHECKLIST_TASK_TEMPLATE_SUCCESS:
      //console.log("REMOVE_CHECKLIST_TASK_TEMPLATE_SUCCESS", state);
      return {
        ...state,
        pending: false,
        checklistTaskTemplates: removeItemFromArray(
          state.checklistTaskTemplates,
          actions.payload.data
        ),
      };
    case types.REMOVE_CHECKLIST_TASK_TEMPLATE_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };

    default:
      return state;
  }
}
